import React from 'react';
import type { YesNoNa } from '../../services/api';

export const InfectionFieldLabel: React.FC<{
  children: React.ReactNode;
  required?: boolean;
}> = ({ children, required }) => (
  <p className='text-sm font-medium mb-1.5'>
    {children}
    {required && <span className='text-destructive ml-0.5'>*</span>}
  </p>
);

export const InfectionYesNoNaGroup: React.FC<{
  label: string;
  name: string;
  value: YesNoNa | '';
  onChange: (v: YesNoNa) => void;
}> = ({ label, name, value, onChange }) => (
  <div className='flex items-center gap-6'>
    <span className='text-sm font-medium w-48 shrink-0'>{label}</span>
    <div className='flex gap-4'>
      {(['yes', 'no', 'na'] as const).map(opt => (
        <label
          key={opt}
          className='flex items-center gap-1.5 cursor-pointer text-sm'
        >
          <input
            type='radio'
            name={name}
            value={opt}
            checked={value === opt}
            onChange={() => onChange(opt)}
            className='accent-primary'
          />
          {opt === 'na' ? 'N/A' : opt.charAt(0).toUpperCase() + opt.slice(1)}
        </label>
      ))}
    </div>
  </div>
);
